import type { Feature } from '../schema';
import { type FeatureDefinitionName, FeatureGate } from '../schema/enums';

/**
 * Checks if an organization has access to the specified features
 *
 * @param featureDefinitionName - the name of the feature definition to be checked
 * @param features - the list of all features for the organization (can be undefined)
 * @returns whether the organization has CX access to the feature
 */
export const checkFeatureAllowedByName = (
  featureDefinitionName: FeatureDefinitionName,
  features: Feature[] | undefined,
): boolean => {
  const feature = features?.find(
    (feat) => feat.definition.featureName === featureDefinitionName,
  );
  if (!feature) return false;

  // feature is allowed if the feature value is not blocked, nonzero, or true
  if (
    (feature.valueFeatureGate &&
      feature.valueFeatureGate !== FeatureGate.Blocked) ||
    feature.valueBoolean === true ||
    (feature.valueNumber && feature.valueNumber > 0)
  ) {
    return true;
  }
  return false;
};
